import { useState } from 'react';
import { TableInput } from '../../../../components/common';
import TBodyRight from './TBodyRight';
import formatDate from '../../../../components/common/formatDate';
import { MenuItem } from '@mui/material';
import CustomSelect from '../../../../components/common/SelectField';
import { DeleteIconButton } from '../../../../components/common/button/CustomIconButton';
import AutocompleteMuiCustom from '../../../../components/common/AutocompleteMuiCustom';
import TBodyRightPDate from './TBodyRightPDate';

interface IProps {
  moduleData: any;
  allmonth: any;
  isView: boolean;
  masterModuleDataForAutoComplete: any;
  handleDeleteRows: any;
}
const TBody = ({
  moduleData,
  isView,
  allmonth,
  masterModuleDataForAutoComplete,
  handleDeleteRows,
}: IProps) => {
  const [tbodyRender, setTBodyRender] = useState(false);
  return (
    <tbody>
      {moduleData?.list?.map((item: any, index: number) => (
        <>
          <tr key={`${index}_table_row`}>
            <td rowSpan={4}>{index + 1}</td>
            <td rowSpan={4} align="left">
              <AutocompleteMuiCustom
                id="a1"
                label=""
                option_name="id_no"
                key={index + 'instrument'}
                arrayofObj={masterModuleDataForAutoComplete}
                value={item?.a1 || ''}
                onChange={(e, value) => {
                  item.a1 = value;
                  setTBodyRender((prev) => !prev);
                }}
              />
            </td>
            <th>P</th>
            {/* always constant ⬇️*/}
            <TBodyRight
              item={item}
              isView={isView}
              index={index}
              allmonth={allmonth}
              setTBodyRender={setTBodyRender}
            />
            <td rowSpan={4} style={{ minWidth: '100px', textAlign: 'center' }}>
              <TableInput
                isView={isView}
                style={{ height: '80px' }}
                name="a5"
                type="text"
                value={item.a5}
                onChange={(e) => {
                  item.a5 = e.target.value;
                  setTBodyRender((prev) => !prev);
                }}
              />
            </td>
            <td rowSpan={4} style={{ minWidth: '100px', textAlign: 'center' }}>
              {!isView && (
                <DeleteIconButton
                  tooltipTitle={'delete'}
                  onClick={() => handleDeleteRows(index)}
                />
              )}
            </td>
          </tr>
          <tr>
            <th>Planned Date</th>
            {/* always constant ⬇️*/}
            <TBodyRightPDate
              item={item}
              isView={isView}
              index={index}
              moduleData={moduleData}
              setTBodyRender={setTBodyRender}
            />
          </tr>
          <tr>
            <th>A</th>
            {allmonth.map((month: any, mIdx: number) => (
              <td
                width="80px"
                height="45px"
                style={{
                  backgroundColor: item[month].doneDate && '#37b24d',
                  color: 'white',
                  textTransform: 'capitalize',
                  fontSize: '1.6rem',
                }}
              >
                {item[month].isTask && 'A'}
              </td>
            ))}
          </tr>
          <tr>
            <th>Actual Date</th>
            {allmonth.map((month: any, mIdx: number) => (
              <td
                width="80px"
                height="45px"
                style={{
                  backgroundColor: item[month].doneDate && '#37b24d',
                  color: 'white',
                  textTransform: 'capitalize',
                  fontSize: '1.6rem',
                }}
              >
                {formatDate(item[month].doneDate) || null}
              </td>
            ))}
          </tr>
          {/* ---x---- */}
        </>
      ))}
    </tbody>
  );
};

export default TBody;
